// CMP Dashboard (24) ds-components/InvoiceActionsMenu.jsx:155-167: the row
// "Actions" button is 13px/600 with 8px 12px padding, a 7px radius, an
// #ECECEC border, an 8px gap and a 13px #727272 chevron. The old 110 px
// minimum came from the design's placeholder hint-size; with the 12 px cell
// padding it ran 2-3 px past the 120 px sticky column, so the button's right
// border was cut off at every width (live check Oct 31 2026).
export const invoiceActionsTriggerSx = {
  borderColor: "#ECECEC",
  borderRadius: "7px",
  color: "#0A0A0A",
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  fontWeight: 600,
  gap: "8px",
  height: 35,
  lineHeight: "normal",
  minWidth: 0,
  padding: "8px 12px",
  textTransform: "none",
  whiteSpace: "nowrap",
  "& .MuiButton-endIcon": { margin: 0 },
  "&:hover": {
    backgroundColor: "white",
    borderColor: "#CBD5E1",
  },
} as const;

export const InvoiceActionsChevron = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#727272"
    strokeWidth="2"
    strokeLinecap="round"
    style={{ width: 13, height: 13 }}
    aria-hidden="true"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);
